import { render, staticRenderFns } from "./MarketingConfigureErrorPage.vue?vue&type=template&id=24653098&scoped=true&"
import script from "./MarketingConfigureErrorPage.vue?vue&type=script&lang=js&"
export * from "./MarketingConfigureErrorPage.vue?vue&type=script&lang=js&"
import style0 from "./MarketingConfigureErrorPage.vue?vue&type=style&index=0&id=24653098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24653098",
  null
  
)

export default component.exports